import PasswordValidator from "components/tools/validation/PasswordValidator.js";
import * as validationConstants from '../constants/validationConstants.jsx';
import EmailAndPhoneValidator from "./EmailAndPhoneValidator.jsx";
import LegalEntityFunctions from "./LegalEntityFunctions.jsx";
import { DIGITS_REGEX } from "components/constants/regexConstants.jsx";

export default {
	validate(prop, value) {
		switch (prop) {
			case "registrationNumber":
			case "registrationNumberRepeat":
				return value.replace(/[^0-9]/g, '');
			case "zipCode":
				return value.replace(/[^0-9]/g, '');
			case "phone":
				return value.replace(/[^0-9]/g, '');
			default:
				return value;
		}
	},
	ifCorrectSymbolsForPlates(input) {

		var letters = /^[0-9a-zA-Z ()-]+$/;
		var result = "";
		for (var i = 0; i < input.length; i++) {
			var char = input.charAt(i);

			if (char.match(letters)) {
				result += char;
			}
		}
		return result;
	},
	ifNumber(input) {
		var result = "";
		for (var i = 0; i < input.length; i++) {
			var char = input.charAt(i);

			if (/\s/g.test(char)) {
				result += char;
			}

			if (isNaN(char)) {
				result += char;
			}
		}
		return result;
	},
	blockSpecialChar(value) {
		return value.replace(/['`~!@#$%^&*()_|+=?;:",.<>{}[\]\\/]/gi, '');
	},
	passwordSatisfiesRequirements(input) {
		const {
			isMinLengthRuleSatisfied,
			isUppercaseLetterRuleSatisfied,
			isLowercaseLetterRuleSatisfied,
			isDigitRuleSatisfied,
			isSpecialSymbolRuleSatisfied
		} = PasswordValidator.getRuleSatisfactionResult(input);

		return isMinLengthRuleSatisfied
			&& isUppercaseLetterRuleSatisfied
			&& isLowercaseLetterRuleSatisfied
			&& isDigitRuleSatisfied
			&& isSpecialSymbolRuleSatisfied;
	},
	validateMandatoryField(prop, value, validations) {
		var errors = [];

		if (prop === 'name' || prop === 'firstName') {
			if (value === null || value === undefined || value.length === 0) {
				errors.push("profile_information_page_mandatory_field_error");
			}
		}
		else if (prop === 'gender') {
			if (value === null || value === undefined || value.length === 0) {
				errors.push("add_your_data_page_select_gender_error");
			}
		}
		else if (prop === 'lastName' || prop === 'Company name'
			|| prop === 'companyName'
			|| prop === 'city' || prop === 'legalAddress'
			|| prop === 'zipCode') {
			if (value === null || value === undefined || value.length === 0) {
				errors.push("profile_information_page_mandatory_field_error");
			} else if (prop === 'companyName' && value.length > validationConstants.COMPANY_NAME_MAX_LENGTH) {
				errors.push('add_your_data_page_mandatory_field_error');
			} else if (prop === 'city' && value.length > validationConstants.CITY_MAX_LENGTH) {
				errors.push('add_your_data_page_mandatory_field_error');
			} else if (prop === 'legalAddress' && value.length > validationConstants.LEGAL_ADDRESS_MAX_LENGTH) {
				errors.push('add_your_data_page_mandatory_field_error');
			}
		}
		else if (prop === "email") {
			const emailStructureError = EmailAndPhoneValidator.getEmailStructureError(value);
			if (emailStructureError) {
				errors.push(emailStructureError);
			}
		}
		else if (prop === 'registrationNumber') {
			if (value === null || value === undefined || value.length === 0) {
				errors.push("add_your_data_page_mandatory_field_error");
			}
			else if (value.length < validations.b2bMinRegistrationNumberLength ||
				value.length > validations.b2bMaxRegistrationNumberLength) {
				errors.push("b2b_profile_information_page_empty_reg_number_error");
			}
		}
		else if (prop === 'phone') {
			if (value === null || value === undefined || value.length === 0) {
				errors.push("add_your_data_page_mandatory_field_error");
			}
		}
		else if (prop === 'isVatPayer') {
			if (value === null || value === undefined) {
				errors.push("add_your_data_page_mandatory_field_error");
			}
		}

		return errors;
	},
	validateBirthDate(
		birthDate,
		validations,
		maxAgeError = "add_your_data_page_birthdate_error",
		minAgeError = "add_your_data_page_birthdate_error",
		emptyFieldError = "enter_additional_information_page_empty_birthdate_field_error"
	) {
		var errors = [];
		if (birthDate === undefined || birthDate === null || birthDate === "" || !isNaN(birthDate)) {
			errors.push(emptyFieldError);
		}
		else {
			const utcSuffix = 'Z';
			// comes with UTC suffix if entered in frontend, without if fetched from DB
			const utcBirthDate = birthDate.endsWith(utcSuffix) ? birthDate : birthDate + utcSuffix;

			const parsedDate = new Date(utcBirthDate);
			const currentDate = new Date();

			const latestValidBirthdate = new Date(Date.UTC(currentDate.getUTCFullYear() - validations.minAge, currentDate.getUTCMonth(), currentDate.getUTCDate(), 0, 0, 0, 0));
			const earliestValidBirthdate = new Date(Date.UTC(currentDate.getUTCFullYear() - validations.maxAge, currentDate.getUTCMonth(), currentDate.getUTCDate() + 1, 0, 0, 0, 0));

			if (parsedDate.getTime() > latestValidBirthdate.getTime()) {
				errors.push(minAgeError)
			} else if (parsedDate.getTime() < earliestValidBirthdate.getTime()) {
				errors.push(maxAgeError);
			}
		}
		return errors;
	},
	getGroomedProfilePropertyChange(key, value) {
		if (key === "name" || key === "lastName" || key === "firstName") {
			return this.blockUnwantedSymbols(value);
		} else if (key === "email") {
			return this.blockSpaceSymbol(value);
		} else {
			return this.validate(key, value);
		}
	},
	blockUnwantedSymbols(name) {
		var result = this.blockSpecialChar(this.ifNumber(name));
		if (name.length === 1) {
			return result.trim().replace('-', '');
		}
		return result;
	},
	blockSpaceSymbol(input) {
		return input.replace(/\s/g, "");
	},
	validateCarPlate(numberPlate) {
		return this.blockSpecialChar(this.ifCorrectSymbolsForPlates(numberPlate)).replace('-', '').replace(/\s/g, '');
	},
	validateNameBeforeSubmit(name) {
		var errors = [];
		let nameProcessed = (name !== null && name !== undefined) ? name.replace(/\s/g, "") : null;

		if (nameProcessed === null || nameProcessed === "") {
			errors.push("add_your_data_page_mandatory_field_error");
		}
		return errors;
	},
	validatePassword(password) {
		const isValid = this.passwordSatisfiesRequirements(password);
		return !isValid
			? ["add_your_data_page_pwd_rules_error"]
			: [];
	},
	validatePasswords(password, confirmPassword, errorMessage = null) {
		var errors = [];
		password = password || "";
		confirmPassword = confirmPassword || "";

		if (password !== confirmPassword) {
			if (errorMessage) {
				errors.push(errorMessage);
			} else {
				errors.push("add_your_data_page_pwd_not_match_error");
			}
		}

		return errors;
	},
	validateRegistrationNumberConfirmation(registrationNumber, repeatRegistrationNumber) {
		const errors = [];
		registrationNumber = registrationNumber || "";
		repeatRegistrationNumber = repeatRegistrationNumber || "";

		if (registrationNumber !== repeatRegistrationNumber) {
			errors.push("b2b_profile_information_page_reg_number_not_match_error");
		}

		return errors;
	},
	getPhoneMinLength(phonePrefixes, selectedPrefix) {
		let validations = phonePrefixes.filter(function (prefix) {
			return prefix.text === selectedPrefix
		});

		let minLength = parseInt(validations[0].minLength);
		let length = parseInt(validations[0].length);

		if (minLength !== null && minLength !== undefined && minLength > 0 && minLength > length) {
			return minLength.toString();
		}
		else {
			return length.toString();
		}
	},
	validatePhonePrefixes(phonePrefixes, selectedPrefix, phoneNumber) {
		let validations = phonePrefixes.filter(function (prefix) {
			return prefix.text === selectedPrefix
		});

		let minLength = parseInt(validations[0].minLength);
		let length = parseInt(validations[0].length);

		if (minLength !== null && minLength !== undefined && minLength > 0) {
			if (minLength < length) {
				if ((phoneNumber === null || phoneNumber === undefined) || phoneNumber.length < minLength || phoneNumber.length > length) {
					return "password_recovery_page_incorrect_phone_field_error";
					// return "phone must have " + minLength + " or " + length + " symbols";
				}
			}
			else {
				if ((phoneNumber === null || phoneNumber === undefined) || phoneNumber.length < length || phoneNumber.length > minLength) {
					return "password_recovery_page_incorrect_phone_field_error";
					// return "phone must have " + length + " or " + minLength + " symbols";
				}
			}
		}
		else {
			if ((phoneNumber === null || phoneNumber === undefined) || phoneNumber.length < length) {
				return "password_recovery_page_incorrect_phone_field_error";
				// return "phone must have " + length + " symbols";
			}
		}

		if ((phoneNumber === null || phoneNumber === undefined) || phoneNumber.length > length) {
			return "password_recovery_page_incorrect_phone_field_error";
			// return "phone must have " + length + " symbols";
		}

		return "";
	},
	validateSeniorIdNumber(seniorIdNumber) {
		var re = /^[A-Za-z]{1,2}[\d]{6,8}$/;
		var isSeniorIdNumberValid = re.exec(seniorIdNumber);

		return isSeniorIdNumberValid ? "" : "senior_club_page_incorrect_nr_error";
	},
	getConsentsDataStepB2BValidationErrors(clientData, companyInformation, initialData, showCurrentPasswordField, currentPassword) {
		const clientDataErrors = Object
			.keys(clientData)
			.map(key => [key, this.validateMandatoryField(key, clientData[key])[0]])
			.filter(pair => pair[1]);

		const companyInformationErrors = Object
			.keys(companyInformation)
			.map(key => [key, this.validateMandatoryField(
				key,
				companyInformation[key],
				initialData.validations
			)[0]])
			.filter(pair => pair[1]);

		const errors = Object.fromEntries(
			clientDataErrors.concat(companyInformationErrors)
		);

		const phoneError = errors.phone || this.validatePhonePrefixes(initialData.phonePrefixes, clientData.phonePrefix, clientData.phone);
		if (phoneError) {
			errors.phone = phoneError;
		}

		if (showCurrentPasswordField && !currentPassword) {
			errors.currentPassword = "profile_information_page_confirm_password_empty_error";
		}

		const vatError = this.getVatFieldError(companyInformation.isVatPayer, companyInformation.vatSuffix, initialData.legalEntityId);
		if (vatError) {
			errors.vatSuffix = vatError;
		}

		return errors;
	},
	getConsentsDataStepB2CValidationErrors(client, initialData, readonlyFlags, showCurrentPasswordField, currentPassword) {
		const errors = Object.fromEntries(
			Object
				.keys(client)
				.map(key => [key, this.validateMandatoryField(key, client[key])[0]])
				.filter(pair => pair[1])
		);

		if (showCurrentPasswordField && !currentPassword) {
			errors.currentPassword = "profile_information_page_confirm_password_empty_error";
		}

		if (!readonlyFlags.birthDate) {
			const birthDateError = this.validateBirthDate(client.birthDate, initialData.validations)[0];
			if (birthDateError) {
				errors.birthDate = birthDateError;
			}
		}

		const phoneError = errors.phone || this.validatePhonePrefixes(initialData.phonePrefixes, client.phonePrefix, client.phone);
		if (phoneError) {
			errors.phone = phoneError;
		}

		return errors;
	},
	getVatFieldError(isVatPayer, vatSuffix, legalEntityId) {
		const error = isVatPayer ? "vat_number_invalid_structure_mandatory_error" : "vat_number_invalid_structure_optional_error"
		if (!vatSuffix) {
			return isVatPayer ? [error] : undefined;
		}

		const isLengthValid = LegalEntityFunctions.getVatNumberLengths()[legalEntityId].includes(vatSuffix.length);
		const isDigitsOnly = DIGITS_REGEX.test(vatSuffix);

		return isLengthValid && isDigitsOnly
			? undefined
			: [error];
	},
	validateLoginForm(model, selectedPrefixId, phonePrefixes) {
		const errors = {};
		let isValid = true;

		if (!model.username && !model.password) {
			errors.username = "login_page_empty_username_error";
			errors.password = "login_page_empty_pwd_error";
			isValid = false;
		} else if (!model.username) {
			errors.username = "login_page_empty_username_error";
			isValid = false;
		} else if (!model.password) {
			errors.password = "login_page_empty_pwd_error";
			isValid = false;
		}

		// Validate phone if a prefix is selected
		if (selectedPrefixId && isValid) {
			const selectedPhonePrefixValue = phonePrefixes.find(prefix => prefix.id === selectedPrefixId)?.text || '';
			if (selectedPhonePrefixValue) {
				const phoneError = this.validatePhonePrefixes(phonePrefixes, selectedPhonePrefixValue, model.username);
				if (phoneError) {
					errors.username = phoneError;
					isValid = false;
				}
			}
		}

		return { errors, isValid };
	}
};
